export default {
  apiTrafficManager: 'https://nakdan-for-morph-analysis.loadbalancer.dicta.org.il/addnikud',
  //nakdanApiTrafficManager: 'https://nikud-search.loadbalancer.dicta.org.il',
  nakdanApiTrafficManager: 'https://nikud-search-1-0.loadbalancer.dicta.org.il'
}
//https://nikud-search.loadbalancer.dicta.org.il/